__turbopack_context__.v({
  "divider": "_0OWEoq_divider",
  "isOrderPage": "_0OWEoq_isOrderPage",
  "localSwitchDropdown": "_0OWEoq_localSwitchDropdown",
  "localeSwitchButton": "_0OWEoq_localeSwitchButton",
  "localeSwitchContainer": "_0OWEoq_localeSwitchContainer",
  "localeSwitchLabel": "_0OWEoq_localeSwitchLabel",
});
